import { useMutation } from 'react-query';
import camelCase from 'lodash/camelCase';
import { useApiFileUpload } from 'src/api';
import { useBuildVars } from 'src/config/build-config';
import { formatObjectKeys } from 'src/util';

export type CustomersUploadRequest = {
  file: File;
};

export type CustomersUploadResponse = {
  customers?: any[];
  message?: string;
  not_found?: any[];
  statusCode?: number;
};

export function useCustomerUpload(onProgress: (progress: number) => void) {
  const buildVars = useBuildVars();
  const { upload } = useApiFileUpload<CustomersUploadResponse>(onProgress, {
    host: buildVars.CG_API_BASE,
  });

  return useMutation((req: CustomersUploadRequest) => {
    const formData = new FormData();
    for (const key in req) {
      const value = (req as any)[key];
      formData.append(key, value);
    }
    return upload('/customers/resolve', formData).then(
      ({ customers, ...res }) => ({
        ...res,
        customers: customers?.map((item: any) =>
          formatObjectKeys<any>(item, camelCase)
        ),
      })
    );
  }, {});
}
